import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Main from "../../components/Layout/Main";
import { Helmet } from 'react-helmet';
import CoverImage from '../../components/CoverImage';
import TextBlock from '../../components/TextBlock/TextBlock';
import PressQuotes from '../../components/PressQuotes/PressQuotes';
import PhotoGrid from '../../components/PhotoGrid';
import LargeEditorial from '../../components/LargeEditorial';
import SmallBoxes from '../../components/SmallBoxes/SmallBoxes';
import ImageBlocks from '../../components/ImageBlocks';

const Insights = () => {
  const { markdownRemark } = useStaticQuery(graphql`
    query InsightsQuery {
      markdownRemark(frontmatter: { pageId: { eq: "insights-page" } }) {
        frontmatter {
          components {
            type
            id
            deeplink
            variant
            content {
              gridImages {
                caption
                featured
                image {
                  childImageSharp {
                    fluid(maxWidth: 2048, quality: 80) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                  extension
                  publicURL
                }
              }
              video {
                src
                loop
                autoplay
                controls
              }
              copy {
                leader
                caption
                trailer
                quotes {
                  line
                  source
                }
                subheads {
                  line
                }
                headlines {
                  line
                }
                scriptHeadline {
                  line
                }
                blocks {
                  type
                  headline
                  headline2
                  headline3
                  headlines {
                    line
                  }
                  bullets {
                    bullet
                  }
                  body {
                    line
                  }
                  body2 {
                    line
                  }
                  icon {
                    childImageSharp {
                      fluid(maxWidth: 2048, quality: 80) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                    extension
                    publicURL
                  }
                }
              }
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
            }
          }
        }
      }
    }
  `)

  const availComponents = {
    CoverImage,
    TextBlock,
    PressQuotes,
    PhotoGrid,
    LargeEditorial,
    SmallBoxes,
    ImageBlocks
  }

  const renderComponents = () => {
    const components = markdownRemark.frontmatter.components;
    let hydratedComponents = [];
    components.forEach((component, i) => {
      // console.log(component.type, component.content)
      const ComponentRef = availComponents[component.type];
      const deeplinkId = component.deeplink ? component.id : '';
      hydratedComponents.push(<ComponentRef key={i} id={deeplinkId} variant={component.variant} {...component.content}/>)
    })
    return hydratedComponents
  }

  return (
    <Main>
      <Helmet>
        <body className="page insights-page" />
      </Helmet>
      {renderComponents()}
    </Main>
  );
}

export default Insights
